import React from "react";

type VisaColorProps = React.SVGProps<SVGSVGElement>;

const VisaColor: React.FC<VisaColorProps> = (props) => (
  <svg viewBox="0 0 120 80" role="img" fill="none" {...props}>
    <title>VISA</title>
    <rect width="120" height="80" rx="4" fill="#FFFFFF" />
    <path
      d="M0,4 C0,1.79 1.79,0 4,0 L116,0 C118.21,0 120,1.79 120,4 L120,10 L0,10 Z"
      fill="#1A1F71"
    />
    <path
      d="M0,70 L120,70 L120,76 C120,78.21 118.21,80 116,80 L4,80 C1.79,80 0,78.21 0,76 Z"
      fill="#F7B600"
    />
    <g fill="#1A1F71" transform="translate(18,27)">
      <path d="M35.747 25.825L28.714 25.825L33.11 0.15L40.143 0.15Z" />
      <path d="M23.407 0.15L17.017 17.809L16.262 14.006L14.007 2.462C14.007 2.462 13.735 0.15 10.828 0.15L0.266 0.15L0.143 0.584C0.143 0.584 3.373 1.254 7.152 3.52L12.975 25.825L19.957 25.825L30.619 0.15Z" />
      <path d="M67.762 17.925L71.419 8.05L73.476 17.925H67.762ZM82.048 25.825L76.904 0.15H69.834C67.448 0.15 66.868 2.063 66.868 2.063L57.286 25.825H63.982L65.322 22.012H73.49L74.243 25.825Z" />
      <path d="M58.282 6.559L59.19 1.231C59.19 1.231 56.385 0.15 53.46 0.15C50.298 0.15 42.791 1.551 42.791 8.361C42.791 14.77 51.602 14.85 51.602 18.214C51.602 21.579 43.699 20.978 41.091 18.855L40.143 24.424C40.143 24.424 42.987 25.825 47.335 25.825C51.682 25.825 58.242 23.542 58.242 17.333C58.242 10.884 49.35 10.283 49.35 7.48C49.35 4.676 55.555 5.036 58.282 6.559" />
      <path d="M15.381 13.975L13.249 2.457C13.249 2.457 12.992 0.15 10.243 0.15L0.259 0.15L0.143 0.583C0.143 0.583 4.942 1.631 9.546 5.553C13.946 9.302 15.381 13.975 15.381 13.975" />
    </g>
  </svg>
);

export default VisaColor;
